import styled from 'styled-components';
import DisplayText from '@sdk/components/ui/DisplayText';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

export const Wrapper = styled.section`
  margin: 0 auto;
  padding: 0 0 20px;
  width: 1200px;
`;

export const Header = styled.header`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  border-radius: 2px 2px 0 0;
  display: flex;
  flex-flow: row nowrap;
  gap: 20px;
  min-height: 77px;
  padding: 20px;

  & > svg {
    display: block;
  }
`;

export const HeaderTitle = styled(DisplayText)`
  margin: 0;
`;
HeaderTitle.defaultProps = {
  fontSize: 18,
  lineHeight: 24,
  semiBold: true,
  themeColor: ThemeColorType.primary,
};

export const SelectionCounter = styled.p`
  all: unset;
  color: ${({ theme }) => theme.colors.gray};
`;

export const HeaderAction = styled.div`
  margin-left: auto;
`;

export const RibbonMenu = styled.ul`
  all: unset;
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  display: flex;
  flex-flow: row nowrap;
  list-style: none;
`;
export const RibbonMenuItem = styled.li``;
export const RibbonMenuButton = styled.button`
  all: unset;
  align-items: center;
  color: ${({ theme }) => theme.colors.iconGray};
  cursor: pointer;
  display: flex;
  flex-flow: column nowrap;
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  padding: 10px 20px;

  & > svg {
    margin-bottom: 5px;
    opacity: 0.8;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const List = styled.ol`
  all: unset;
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  display: flex;
  list-style: none;
  flex-flow: column nowrap;
`;

export const ListItem = styled.li`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.gray};
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.hoverLighter};
  }

  &:not(:first-of-type) {
    border-top: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  }

  & > svg {
    display: block;
  }
`;
